import { buildBulkRequestService } from '../../../../../components/bulkRequest';
import { API_ENDPOINTS, FORWARD_ROUTES } from '../constants';
import { SERVICE_NAMES } from '../../../../../settingsV2Enum';

export default buildBulkRequestService(API_ENDPOINTS, FORWARD_ROUTES, {
	SERVICE_NAME: SERVICE_NAMES.AUTH
});
